import dayjs from 'dayjs'

const format = 'HH:mm'

// Get branch schedule status
export const isWorkingHour = (start?: string, end?: string) => {
  const currentTime = dayjs()

  if (start && end) {
    const workHourStart = dayjs(start, format, true)
    const workHourEnd = dayjs(end, format, true)

    if (start === '00:00' && end === '23:59') {
      return true
    }

    if (workHourEnd.isBefore(workHourStart)) {
      if (
        currentTime.isAfter(workHourStart) ||
        currentTime.isBefore(workHourEnd)
      ) {
        return true
      }
    } else {
      if (
        currentTime.isAfter(workHourStart) &&
        currentTime.isBefore(workHourEnd)
      ) {
        return true
      }
    }

    return false
  }

  return true
}
